import { get } from "lodash";
import styled from "styled-components";
import { TextField as MuiTextField } from "@mui/material";

import { colors } from "../pages/css components/Style";

const TextFieldWithCSS = styled(MuiTextField)`
  .MuiTextField-root {
    color :${colors.text}
    border-color: ${colors.publicisBlue} !important;
  }

  & label.Mui-focused {
    color: ${colors.publicisBlue};
  }

  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: ${colors.publicisBlue};
    }
  }

  .MuiInputLabel-root {
    color :${colors.text};
  }

  .MuiOutlinedInput-notchedOutline {
    border-radius: 5px;
    border-color: ${colors.publicisBlue};
  }

   & .MuiOutlinedInput-root {
    font-size: 16px;
    color: ${colors.text};
    border-radius: 5px;

    .MuiOutlinedInput-notchedOutline {
      border-color: ${(props) =>
        props.$isFilled ? colors.publicisBlue : colors.grey};
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${colors.publicisBlue};
      border-width: 2px;
    }
  }

  .Mui-disabled {
    color: rgba(0, 0, 0, 0.66);
    font-size: 16px;
    border-radius: 5px;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.66);
  }

  .MuiInputLabel-outlined {
    font-size: 16px;
    color :${colors.text}
  }

  .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: #f5f5f5;
    border: 1px solid #c4cacb;
  }

  .MuiInputBase-input {
    color :${colors.text}
    border-color: ${colors.publicisBlue};
  }
  
  #mui-7-helper-text {
    color: red;
  }
  .MuiInputLabel-asterisk {
    color: ${(props) => (Boolean(props.required && !props.value) ? "red" : "")};
  }

`;

export default function TextField({ formikProps, ...props }) {
  let value = "";
  if (!!formikProps) {
    value = get(formikProps.values, props.name, "");

    function handleTouch() {
      if (Object.keys(formikProps?.touched).length > 0) {
        for (let field in formikProps.touched) {
          if (field !== props.name) {
            formikProps.setTouched({
              ...formikProps.touched,
              [props.name]: true,
            });
          } else {
            formikProps.setTouched({ [props.name]: true });
          }
        }
      } else {
        formikProps.setTouched({ [props.name]: true });
      }
    }
    return (
      <TextFieldWithCSS
        size="small"
        $isFilled={!!value}
        onClick={handleTouch}
        onChange={formikProps.handleChange}
        error={
          get(formikProps.touched, props.name) && props.select
            ? Boolean(
                !get(formikProps.values, props.name) &&
                  get(formikProps.errors, props.name)
              )
            : !!get(formikProps.touched, props.name) &&
              get(formikProps.errors, props.name)
        }
        helperText={
          get(formikProps.touched, props.name) && props.select
            ? !get(formikProps.values, props.name) &&
              get(formikProps.errors, props.name)
            : !!get(formikProps.touched, props.name) &&
              get(formikProps.errors, props.name)
        }
        onBlur={formikProps.handleBlur}
        value={get(formikProps.values, props.name, "")}
        fullWidth
        variant="outlined"
        slotProps={{
          inputLabel: {
            shrink: Boolean(value),
          },
        }}
        {...props}
      />
    );
  }

  return (
    <TextFieldWithCSS
      variant="outlined"
      $isFilled={props.$isFilled}
      fullWidth
      {...props}
    />
  );
}
